/* ═══════════════════════════════════════════
   Sleep Quiz — Expert Health Co
   Asset: sleep-quiz.js v10
   ═══════════════════════════════════════════ */
(function() {
'use strict';

var root = document.getElementById('sleepQuiz');
if (!root) return;

var WORKER_URL = root.dataset.workerUrl || '';
var PDP_URL = root.dataset.pdpUrl || '';
var PRODUCT_IMG = root.dataset.productImg || '';
var TRACKING_URL = root.dataset.trackingUrl || '';

var LOADING_MESSAGES = [
'Analysing your sleep profile...',
'Scanning 5,000+ sleep products...',
'Analysing 1,000,000+ customer reviews & results...',
'Building your personalised recommendation...'
  ];

var history = [];
var currentPhase = '1';
var processing = false;
var hasStarted = false;
var confirmedSymptoms = [];  // Only populated from chip selections, never free text

var chatEl = document.getElementById('sqChat');
var welcomeEl = document.getElementById('sqWelcome');
var inputEl = document.getElementById('sqInput');
var sendEl = document.getElementById('sqSend');
var inputArea = document.getElementById('sqInputArea');

function wait(ms) { return new Promise(function(r) { setTimeout(r, ms); }); }
function scroll() { requestAnimationFrame(function() { chatEl.scrollTop = chatEl.scrollHeight; }); }
function esc(t) { return t.replace(/</g, '&lt;').replace(/>/g, '&gt;'); }


// ═══════════════════════════════════════════
// TRACKING
// ═══════════════════════════════════════════

function getSessionId() {
  var sid = sessionStorage.getItem('sq_tracking_id');
  if (!sid) {
    sid = Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    sessionStorage.setItem('sq_tracking_id', sid);
  }
  return sid;
}

function trackEvent(event, extra) {
  if (!TRACKING_URL) return;
  var payload = { event: event, sessionId: getSessionId() };
  if (extra) {
    for (var k in extra) {
      if (extra.hasOwnProperty(k)) payload[k] = extra[k];
    }
  }
  // Use text/plain so no-cors doesn't strip the content-type
  // Google Apps Script reads e.postData.contents regardless
  fetch(TRACKING_URL, {
    method: 'POST',
    mode: 'no-cors',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify(payload)
  }).catch(function() {});
}

function trackMessage(text) {
  trackEvent('user_message', { text: text });
}


// ═══════════════════════════════════════════
// SESSION PERSISTENCE (survives page refresh)
// ═══════════════════════════════════════════

var SESSION_KEY = 'sq_session';
var SESSION_TTL = 30 * 60 * 1000; // 30 minutes

function saveSession() {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify({
      history: history,
      phase: currentPhase,
      symptoms: confirmedSymptoms,
      ts: Date.now()
    }));
  } catch (e) { /* quota exceeded or private mode */ }
}

function clearSession() {
  try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
}

// Strip interactive blocks from restored messages (chips already submitted)
function stripChips(text) {
  return text
    .replace(/\|\|\|CHIPS_PROFILE\|\|\|[\s\S]*?\|\|\|END_CHIPS_PROFILE\|\|\|/g, '')
    .replace(/\|\|\|CHIPS\|\|\|[\s\S]*?\|\|\|END_CHIPS\|\|\|/g, '');
}

function restoreSession() {
  try {
    var raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return false;
    var data = JSON.parse(raw);

    if (Date.now() - data.ts > SESSION_TTL) {
      clearSession();
      return false;
    }

    history = data.history;
    currentPhase = data.phase;
    confirmedSymptoms = data.symptoms || [];
    hasStarted = true;

    if (welcomeEl) welcomeEl.style.display = 'none';
    inputEl.placeholder = 'Type your response...';

    // Replay messages — chips are stripped (already submitted), cards/testimonials still render
    history.forEach(function(msg) {
      if (msg.role === 'user') {
        addMsg('user', '<p>' + esc(msg.content) + '</p>');
      } else {
        addMsg('ai', parseMessage(stripChips(msg.content)));
      }
    });

    return true;
  } catch (e) { return false; }
}


// ═══════════════════════════════════════════
// UI
// ═══════════════════════════════════════════

function addMsg(role, html, noScroll) {
  var row = document.createElement('div');
  row.className = 'sq-msg ' + (role === 'ai' ? 'sq-ai' : 'sq-user');
  row.innerHTML =
    '<div class="sq-msg-inner">' +
    '<div class="sq-av">' + (role === 'ai' ? '🌙' : 'Y') + '</div>' +
    '<div class="sq-body">' + html + '</div>' +
    '</div>';
  chatEl.appendChild(row);
  if (!noScroll) scroll();
  return row;
}

function showTyping(noScroll) {
  var row = document.createElement('div');
  row.className = 'sq-typing'; row.id = 'sqTyping';
  row.innerHTML =
    '<div class="sq-msg-inner">' +
    '<div class="sq-av" style="background:var(--sq-accent);color:#fff">🌙</div>' +
    '<div class="sq-typing-wrap">' +
    '<div class="sq-dots"><div class="sq-dot"></div><div class="sq-dot"></div><div class="sq-dot"></div></div>' +
    '<span class="sq-typing-text">Analysing</span>' +
    '</div>' +
    '</div>';
  chatEl.appendChild(row);
  if (!noScroll) scroll();
}

function hideTyping() {
  var el = document.getElementById('sqTyping');
  if (el) el.remove();
}

function showLoading() {
  var row = document.createElement('div');
  row.className = 'sq-loading'; row.id = 'sqLoading';
  var steps = LOADING_MESSAGES.map(function(msg) {
    return '<div class="sq-loading-step"><div class="sq-step-icon"></div><span>' + msg + '</span></div>';
  }).join('');
  row.innerHTML =
    '<div class="sq-loading-inner"><div class="sq-loading-steps">' + steps + '</div></div>';
  chatEl.appendChild(row); scroll();

  var stepEls = row.querySelectorAll('.sq-loading-step');
  var idx = 0;
  if (stepEls[0]) stepEls[0].classList.add('sq-active');

  var interval = setInterval(function() {
    if (stepEls[idx]) {
      stepEls[idx].classList.remove('sq-active');
      stepEls[idx].classList.add('sq-done');
    }
    idx++;
    if (idx >= stepEls.length) { clearInterval(interval); return; }
    stepEls[idx].classList.add('sq-active');
    scroll();
  }, 1800);

  return interval;
}

function hideLoading(interval) {
  if (interval) clearInterval(interval);
  var el = document.getElementById('sqLoading');
  if (el) {
    el.querySelectorAll('.sq-loading-step').forEach(function(s) {
      s.classList.remove('sq-active');
      s.classList.add('sq-done');
    });
    setTimeout(function() { el.remove(); }, 400);
  }
}


// ═══════════════════════════════════════════
// BLOCK PARSERS
// ═══════════════════════════════════════════

function cleanBlockJson(raw) {
  return raw.trim()
    .replace(/\\n/g, ' ')
    .replace(/\\"/g, '"')
    .replace(/\n/g, ' ');
}

function parseMessage(text) {
  var html = text.replace(/\\n/g, '\n');

  // Product card — now passes full data object (reasons + stat)
  var cardMatch = html.match(/\|\|\|PRODUCT_CARD\|\|\|([\s\S]*?)\|\|\|END_CARD\|\|\|/);
  if (cardMatch) {
    try { html = html.replace(cardMatch[0], renderProductCard(JSON.parse(cleanBlockJson(cardMatch[1])))); }
    catch (e) { console.error('Card parse:', e, cardMatch[1]); }
  }

  // Testimonial
  var testiMatch = html.match(/\|\|\|TESTIMONIAL\|\|\|([\s\S]*?)\|\|\|END_TESTIMONIAL\|\|\|/);
  if (testiMatch) {
    try { html = html.replace(testiMatch[0], renderTestimonial(JSON.parse(cleanBlockJson(testiMatch[1])))); }
    catch (e) { console.error('Testi parse:', e, testiMatch[1]); }
  }

  // Profile chips
  var profileMatch = html.match(/\|\|\|CHIPS_PROFILE\|\|\|([\s\S]*?)\|\|\|END_CHIPS_PROFILE\|\|\|/);
  if (profileMatch) {
    try { html = html.replace(profileMatch[0], renderProfileChips(JSON.parse(cleanBlockJson(profileMatch[1])))); }
    catch (e) { console.error('Profile chips parse:', e, profileMatch[1]); }
  }

  // Generic chips
  var chipsMatch = html.match(/\|\|\|CHIPS\|\|\|([\s\S]*?)\|\|\|END_CHIPS\|\|\|/);
  if (chipsMatch) {
    try {
      var parsed = JSON.parse(cleanBlockJson(chipsMatch[1]));
      html = html.replace(chipsMatch[0], renderChips(parsed, 'multi'));
    } catch (e) { console.error('Chips parse:', e, chipsMatch[1]); }
  }

  // Newlines to paragraphs
  html = html.split('\n\n').map(function(p) { return p.trim(); }).filter(Boolean).map(function(p) {
    if (p.charAt(0) === '<') return p;
    return '<p>' + p + '</p>';
  }).join('');

  return html;
}

function renderProductCard(data) {
  // Handle both old format (array) and new format (object with reasons + stat)
  var reasons = Array.isArray(data) ? data : (data.reasons || []);
  var stat = Array.isArray(data) ? '' : (data.stat || '');

  // Hardcode product image — Shopify section setting may have stale cached value
  var imgSrc = 'https://cdn.shopify.com/s/files/1/0664/1156/1069/files/Add_a_heading_18.jpg?v=1773901636';

  var html = '' +
    '<div class="sq-pc">' +
    '<div class="sq-pc-accent"><span class="sq-pc-accent-text">97.3% Personalised Match</span></div>' +
    '<div class="sq-pc-header">' +
    '<div class="sq-pc-img"><img src="' + imgSrc + '" alt="SLEEP." onerror="this.parentElement.textContent=\'🌙\'"></div>' +
    '<div class="sq-pc-info">' +
    '<div class="sq-pc-name">SLEEP.</div>' +
    '<div class="sq-pc-sub">Natural Sleep Complex · 8 Active Ingredients</div>' +
    '<div class="sq-pc-tags">' +
    '<span class="sq-pc-tag">Drug Free</span>' +
    '<span class="sq-pc-tag">Non-Habit Forming</span>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '<div class="sq-pc-divider"></div>';

  if (stat) {
    html += '<div class="sq-pc-stat">' + stat + '</div>';
  }

  html +=
    '<div class="sq-pc-reasons">' +
    reasons.map(function(r) {
      return '<div class="sq-pc-reason"><span class="sq-chk">&#10003;</span><span>' + r + '</span></div>';
    }).join('') +
    '</div>' +
    '<div class="sq-pc-reviews"><span class="sq-pc-stars">★★★★★</span><span class="sq-pc-rating">4.8/5 · 2,847 reviews</span></div>' +
    '<div class="sq-pc-price-section"><div class="sq-pc-price-row">' +
    '<span class="sq-pc-from">From</span>' +
    '<span class="sq-pc-price">$19.99</span>' +
    '<span class="sq-pc-per">/jar</span>' +
    '<span class="sq-pc-was">$49.99</span>' +
    '<span class="sq-pc-save">Save Up To 60%</span>' +
    '</div></div>' +
    '<a href="' + PDP_URL + '" target="_blank" class="sq-pc-cta" onclick="trackEvent(\'product_cta_click\')">Try SLEEP. Risk-Free for 365 Days</a>' +
    '<div class="sq-pc-foot">365-Day Money Back Guarantee · Free Shipping</div>' +
    '</div>';

  return html;
}

function renderTestimonial(data) {
  var stars = '';
  for (var i = 0; i < (data.stars || 5); i++) stars += '★';
  return '' +
    '<div class="sq-testi">' +
    '<div class="sq-testi-stars">' + stars + '</div>' +
    '<div class="sq-testi-text">"' + data.text + '"</div>' +
    '<div class="sq-testi-who">' + data.author + ' · <span class="sq-v">Verified Buyer</span></div>' +
    '</div>';
}


// ─── PROFILE CHIPS (Gender + Age with labels) ───

function renderProfileChips(data) {
  var id = 'sq-profile-' + Date.now();
  setTimeout(function() { bindProfileChips(id); }, 50);

  var html = '<div id="' + id + '" class="sq-profile-chips">';
  data.groups.forEach(function(group) {
    html += '<div class="sq-chip-group">';
    html += '<div class="sq-chip-label">' + group.label + '</div>';
    html += '<div class="sq-chips">';
    group.options.forEach(function(opt) {
      html += '<button class="sq-chip" data-group="' + group.label.toLowerCase() + '" data-value="' + opt + '">' + opt + '</button>';
    });
    html += '</div></div>';
  });
  html += '<button class="sq-chip-submit sq-profile-submit" disabled>Continue</button>';
  html += '</div>';
  return html;
}

function bindProfileChips(id) {
  var wrap = document.getElementById(id);
  if (!wrap) return;

  var selections = {};
  var submitBtn = wrap.querySelector('.sq-profile-submit');
  var groups = wrap.querySelectorAll('.sq-chip-group');

  groups.forEach(function(group) {
    var chips = group.querySelectorAll('.sq-chip');
    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        chips.forEach(function(c) { c.classList.remove('sq-selected'); });
        chip.classList.add('sq-selected');
        selections[chip.getAttribute('data-group')] = chip.getAttribute('data-value');
        var allSelected = Object.keys(selections).length >= groups.length;
        submitBtn.disabled = !allSelected;
      });
    });
  });

  submitBtn.addEventListener('click', function() {
    if (submitBtn.disabled) return;
    wrap.querySelectorAll('.sq-chip').forEach(function(c) { c.classList.add('sq-disabled'); });
    submitBtn.style.display = 'none';

    var gender = selections.gender || 'Prefer not to say';
    var age = selections.age || 'Unknown';

    trackEvent('profile_submit', { age: age, gender: gender });
    trackMessage(gender + ', ' + age);

    addMsg('user', '<p>' + gender + ', ' + age + '</p>');
    history.push({ role: 'user', content: gender + ', ' + age });
    sendToWorker();
  });
}


// ─── GENERIC CHIPS (multi-select with continue) ───

function renderChips(labels, type) {
  var id = 'sq-chips-' + Date.now();
  setTimeout(function() { bindMultiChips(id); }, 50);

  var html = '<div id="' + id + '"><div class="sq-chips">';
  labels.forEach(function(label) {
    html += '<button class="sq-chip" data-value="' + label + '">' + label + '</button>';
  });
  html += '</div>';
  html += '<button class="sq-chip-submit">Continue</button>';
  html += '</div>';
  return html;
}

function bindMultiChips(id) {
  var wrap = document.getElementById(id);
  if (!wrap) return;

  var chips = wrap.querySelectorAll('.sq-chip');
  var submitBtn = wrap.querySelector('.sq-chip-submit');
  var selected = new Set();

  chips.forEach(function(chip) {
    chip.addEventListener('click', function() {
      var val = chip.getAttribute('data-value');

      if (val.toLowerCase().indexOf('none') === 0) {
        selected.clear();
        chips.forEach(function(c) { c.classList.remove('sq-selected'); });
        chip.classList.add('sq-selected');
        selected.add(val);
        return;
      }

      chips.forEach(function(c) {
        if (c.getAttribute('data-value').toLowerCase().indexOf('none') === 0) {
          c.classList.remove('sq-selected');
          selected.delete(c.getAttribute('data-value'));
        }
      });

      chip.classList.toggle('sq-selected');
      if (selected.has(val)) selected.delete(val);
      else selected.add(val);
    });
  });

  submitBtn.addEventListener('click', function() {
    if (selected.size === 0) return;
    chips.forEach(function(c) { c.classList.add('sq-disabled'); });
    submitBtn.style.display = 'none';

    var labels = Array.from(selected).join(', ');

    // Track confirmed symptoms from chips (not free text)
    Array.from(selected).forEach(function(s) {
      if (s.toLowerCase().indexOf('none') !== 0) confirmedSymptoms.push(s);
    });

    trackMessage(labels);
    addMsg('user', '<p>' + labels + '</p>');
    history.push({ role: 'user', content: labels });
    sendToWorker();
  });
}


// ═══════════════════════════════════════════
// WORKER COMMUNICATION
// ═══════════════════════════════════════════

// Bridge: strong value statement + single CTA (no opt-out)
function showBridge() {
  return new Promise(function(resolve) {
    var symptomText;
    if (confirmedSymptoms.length > 0) {
      symptomText = confirmedSymptoms.slice(0, 3).join(', ').toLowerCase();
    } else {
      symptomText = 'your sleep issues';
    }

    var bridgeContent = 'I have access to over 5,000 sleep products available in the USA. Based on what you\'ve told me, I can recommend the exact product for your ' + symptomText + '.';

    var bridgeHtml = '<p><strong>I have access to over 5,000 sleep products available in the USA.</strong></p>' +
      '<p>Based on what you\'ve told me, I can recommend the exact product for your ' + symptomText + '.</p>';

    var id = 'sq-bridge-' + Date.now();
    bridgeHtml += '<div id="' + id + '">' +
      '<button class="sq-bridge-cta" style="display:block;width:100%;max-width:360px;padding:14px 20px;margin-top:16px;background:var(--sq-accent,#1a7f64);color:#fff;border:none;border-radius:8px;font-family:inherit;font-size:15px;font-weight:600;cursor:pointer;text-align:center">Find My Personalised Solution</button>' +
      '</div>';

    addMsg('ai', bridgeHtml);
    history.push({ role: 'assistant', content: bridgeContent });

    setTimeout(function() {
      var btn = document.querySelector('#' + id + ' .sq-bridge-cta');
      if (btn) {
        btn.addEventListener('click', function() {
          btn.classList.add('sq-disabled');
          btn.textContent = 'Searching...';
          trackEvent('recommendation_cta_click');
          history.push({ role: 'user', content: 'Yes, find my personalised solution' });
          resolve();
        });
      }
    }, 50);
  });
}

// Split Beat 5 into exactly 2 segments:
// 1. Everything before the product card (intro + testimonial + risk reversal — one compact message)
// 2. Product card (standalone, last — lands at bottom of chat)
function splitRecommendation(text) {
  var normalized = text.replace(/\\n/g, '\n');
  var cardMatch = normalized.match(/\|\|\|PRODUCT_CARD\|\|\|[\s\S]*?\|\|\|END_CARD\|\|\|/);
  if (!cardMatch) return [text];

  var cardIdx = normalized.indexOf(cardMatch[0]);
  var beforeCard = normalized.substring(0, cardIdx).trim();
  var afterCard = normalized.substring(cardIdx + cardMatch[0].length).trim();

  var segments = [];
  if (beforeCard) segments.push(beforeCard);

  // Card is always the final segment — append any trailing text to it
  segments.push(afterCard ? cardMatch[0] + '\n\n' + afterCard : cardMatch[0]);

  return segments;
}

// Handle the entire Opus flow inline (bridge → loading → API → display)
// This prevents the double-bridge bug from recursive sendToWorker calls
async function handleOpusFlow() {
  await wait(1500);

  // Show bridge
  showTyping();
  await wait(1200);
  hideTyping();

  await showBridge();

  // User clicked CTA — show loading and fetch Opus recommendation
  processing = true;
  var loadingInterval = showLoading();
  var startTime = Date.now();

  try {
    var response = await fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        messages: history,
        requestPhase: '5'
      })
    });

    var data = await response.json();

    // Ensure loading animation runs for at least 7 seconds
    var elapsed = Date.now() - startTime;
    if (elapsed < 7000) await wait(7000 - elapsed);

    hideLoading(loadingInterval);
    showTyping();
    await wait(1000);
    hideTyping();

    if (data.error) {
      addMsg('ai', '<p>Something went wrong. Please try again.</p>');
      processing = false;
      return;
    }

    if (data.phase) currentPhase = String(data.phase);
    var rawMessage = data.message || '';
    history.push({ role: 'assistant', content: rawMessage });

    // Stagger: segment 1 = intro + testimonial + risk reversal (compact)
    //          segment 2 = product card (standalone, lands at bottom)
    var segments = splitRecommendation(rawMessage);

    for (var i = 0; i < segments.length; i++) {
      if (i > 0) {
        showTyping(true);
        await wait(1500);
        hideTyping();
      }
      addMsg('ai', parseMessage(segments[i]));
    }

    saveSession();
    inputEl.placeholder = 'Ask a follow-up question...';
    clearSession();

  } catch (err) {
    console.error('Sleep quiz error:', err);
    hideLoading(loadingInterval);
    addMsg('ai', '<p>Connection issue. Please try again.</p>');
  }

  processing = false;
  inputEl.focus();
}

async function sendToWorker() {
  if (processing) return;
  processing = true;

  // Track quiz start on first interaction
  if (!window._sqTrackedStart) {
    trackEvent('quiz_start');
    window._sqTrackedStart = true;
  }

  showTyping();
  await wait(800 + Math.random() * 1000);

  try {
    var response = await fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        messages: history,
        requestPhase: currentPhase
      })
    });

    var data = await response.json();
    hideTyping();

    if (data.error) {
  addMsg('ai', '<p>' + data.error + '</p>');
  processing = false;
  return;
}


    if (data.phase) currentPhase = String(data.phase);
    var rawMessage = data.message || '';

    // Safety: if the AI included chips, FORCE awaitResponse=true
    // (chips need user interaction — don't auto-continue past them)
    if (rawMessage.indexOf('|||CHIPS|||') !== -1 || rawMessage.indexOf('|||CHIPS_PROFILE|||') !== -1) {
      data.awaitResponse = true;
    }

    history.push({ role: 'assistant', content: rawMessage });
    addMsg('ai', parseMessage(rawMessage));
    saveSession();

    if (data.done) {
      inputEl.placeholder = 'Ask a follow-up question...';
      clearSession();
    }

    processing = false;

    // Auto-continue: Beat 4 sets awaitResponse=false
    // This triggers the Opus flow (bridge → loading → recommendation)
    // Handled inline via handleOpusFlow to prevent double-bridge bug
    if (data.awaitResponse === false && !data.done) {
      handleOpusFlow();
      return;
    }

  } catch (err) {
    console.error('Sleep quiz error:', err);
    hideTyping();
    addMsg('ai', '<p>Connection issue. Please try again.</p>');
    processing = false;
  }

  inputEl.focus();
}


// ═══════════════════════════════════════════
// USER INPUT
// ═══════════════════════════════════════════

function sendMessage(text) {
  if (processing || !text.trim()) return;
  if (welcomeEl) welcomeEl.style.display = 'none';

  if (!hasStarted) {
    hasStarted = true;
    inputEl.placeholder = 'Type your response...';
  }

  trackMessage(text);
  addMsg('user', '<p>' + esc(text) + '</p>');
  history.push({ role: 'user', content: text });
  inputEl.value = '';
  inputEl.style.height = 'auto';
  sendEl.disabled = true;
  sendToWorker();
}


// ═══════════════════════════════════════════
// INIT
// ═══════════════════════════════════════════

restoreSession();

inputEl.addEventListener('input', function() {
  sendEl.disabled = !inputEl.value.trim();
  inputEl.style.height = 'auto';
  inputEl.style.height = Math.min(inputEl.scrollHeight, 120) + 'px';
});

inputEl.addEventListener('keydown', function(e) {
  if (e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault();
    sendMessage(inputEl.value.trim());
  }
});

sendEl.addEventListener('click', function() {
  sendMessage(inputEl.value.trim());
});

// Expose trackEvent globally for inline onclick handlers (product card CTA)
window.trackEvent = trackEvent;

})();
